import type { IntlShape } from "@formatjs/intl";
import { Skeleton } from "antd";
import type { HookAPI } from "antd/es/modal/useModal";
import { connect, type DispatchProp } from "react-redux";
import type { State as RouterState } from "router5";
import ConnectedAppLayout from "../../AppLayout";
import type { RootState } from "../../store";
import { ErrorBoundary } from "../../../common/components/ErrorBoundary";
import type {
	Materials,
	ModelFile,
	Services,
	TicketRetrieve,
} from "../../generated-axios-client";
import { TicketViewRender } from "./TicketViewRender";

export type TicketViewProps = {
	intl: IntlShape<string>;
	currentRoute: RouterState | null;
	ticket: TicketRetrieve | null;
	serviceObjects: Record<string, Services> | null;
	files: ModelFile[] | null;
	materialsList: Materials[] | undefined;
	modalApi: HookAPI | undefined;
};

const TicketView = (props: TicketViewProps & DispatchProp) => {
	const {
		intl,
		currentRoute,
		modalApi,
		ticket,
		serviceObjects,
		files,
		materialsList,
		dispatch,
	} = props;

	if (!ticket || !serviceObjects) {
		return <Skeleton active />;
	}

	const materialCatalog = Object.fromEntries(
		(materialsList ?? []).map((m) => [m.id, m.name]),
	);

	const sapCodeCatalog = Object.fromEntries(
		(materialsList ?? []).map((m) => [m.id, m.sap_code ?? null]),
	);

	const categoryCatalog = Object.fromEntries(
		(materialsList ?? []).map((m) => [m.id, m.category ?? null]),
	);

	const ticketData = {
		ticket,
		serviceObjects,
		files,
		materialCatalog,
		sapCodeCatalog,
		categoryCatalog,
	};

	return (
		<ConnectedAppLayout>
			<ErrorBoundary>
				<TicketViewRender
					intl={intl}
					currentRoute={currentRoute}
					ticketData={ticketData}
					modalApi={modalApi}
					dispatch={dispatch}
				/>
			</ErrorBoundary>
		</ConnectedAppLayout>
	);
};

const withTicketView = (state: RootState) => ({
	ticket: state.ticket.ticket,
	serviceObjects: state.ticket.servicesObj,
	files: state.ticket.ticketFiles,
	materialsList: state.ticketData.materials,
	currentRoute: state.router.route,
	intl: state.intl.datetimeIntl,
	modalApi: state.appFeedback.modal,
});

export const ConnectedTicketViewPage = connect(withTicketView)(TicketView);

export default ConnectedTicketViewPage;
